/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";
import { invalidateAvailability } from "./invalidateAvailability";

export const useRescheduleBooking = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.rescheduleBooking(id),
    mutationFn: ({ start_datetime, hash }) =>
      fetcher({
        method: "POST",
        url: `/public/booking/reschedule/id/${id}`,
        data: {
          start_datetime,
          ...(hash ? { hash } : {}),
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.booking.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.client.bookingsAll });
      invalidateAvailability(queryClient);
    },
  });
};
